<template>
  <div>
    <Main
      ref="main"
      :tableData="tableData"
      :loading="loading"
      :tablePage="page"
      @reload="getData"
    >
      <pagination
        size="small"
        align="right"
        slot="pager"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </Main>
  </div>
</template>
<script>
import BaseTable from "@/mixins/base-table"
import Main from "./main.vue"
export default {
  mixins: [BaseTable],
  components: { Main },
  props: {
    code: String,
  },
  data() {
    return {
      loading: false,
      usePage: true,
    }
  },
  methods: {
    getData() {
      if (!this.code) return
      this.loading = true
      this.$api
        .mrpMaterialPlanDetailListApi({
          mrpMaterialPlanCode: this.code,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
  mounted() {
    this.getData()
  },
}
</script>
